/**
 * Checkout floating labels, delivery-first address panels, and order-notes disclosure.
 */

function getConfig() {
	return window.doneCommerce || {};
}

function isFilled(control) {
	if (!control) {
		return false;
	}

	if (control.tagName === 'SELECT') {
		const value = control.value;
		return Boolean(value && value !== '' && value !== null);
	}

	if (control.type === 'checkbox' || control.type === 'radio') {
		return control.checked;
	}

	return String(control.value || '').trim() !== '';
}

function syncFloatingRow(row) {
	if (
		!row ||
		row.closest('.dc-ship-toggle') ||
		row.classList.contains('create-account') ||
		row.classList.contains('dc-marketing-consent') ||
		row.querySelector('input[type="checkbox"], input[type="radio"]')
	) {
		return;
	}

	const control =
		row.querySelector('input.input-text, input[type="email"], input[type="tel"], input[type="text"], input[type="number"], textarea, select') ||
		row.querySelector('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])');

	if (!control) {
		return;
	}

	const filled = isFilled(control);
	row.classList.toggle('is-filled', filled);
	row.classList.toggle('is-floating', filled || document.activeElement === control);
}

function syncAllFloating(root = document) {
	root.querySelectorAll('.dc-checkout .form-row').forEach((row) => syncFloatingRow(row));
}

function ensureOrderNotesDisclosure() {
	const fields = document.querySelector('.dc-checkout .woocommerce-additional-fields');
	if (!fields || fields.querySelector('.dc-order-notes')) {
		return;
	}

	const wrapper = fields.querySelector('.woocommerce-additional-fields__field-wrapper');
	if (!wrapper) {
		return;
	}

	const details = document.createElement('details');
	details.className = 'dc-order-notes';
	const summary = document.createElement('summary');
	summary.textContent = getConfig().i18n?.addOrderNote || 'Add a note to your order';
	details.appendChild(summary);
	wrapper.parentNode?.insertBefore(details, wrapper);
	details.appendChild(wrapper);
}

function getWcShipCheckbox() {
	return document.getElementById('ship-to-different-address-checkbox');
}

function getBillingDifferentToggle() {
	return document.querySelector('[data-billing-different]');
}

function getDeliveryMethod() {
	const form = document.querySelector('[data-dc-checkout]');
	const method = form?.dataset.deliveryMethod || '';
	return method === 'collection' || method === 'delivery' ? method : '';
}

function setDeliveryMethod(method) {
	const form = document.querySelector('[data-dc-checkout]');
	if (!form) {
		return;
	}
	form.dataset.deliveryMethod = method;
}

function ensureDeliveryHeading() {
	const shippingFields = document.querySelector('.dc-checkout .woocommerce-shipping-fields');
	if (!shippingFields) {
		return null;
	}

	let heading = shippingFields.querySelector('[data-delivery-title]');
	if (!heading) {
		heading = document.createElement('h3');
		heading.setAttribute('data-delivery-title', '');
		shippingFields.insertBefore(heading, shippingFields.firstChild);
	}
	return heading;
}

function updateHeadings(method, onBillingPanel) {
	const i18n = getConfig().i18n || {};
	const billingHeading = document.querySelector('.dc-checkout .woocommerce-billing-fields > h3');
	const shippingHeading = ensureDeliveryHeading();

	if (method === 'collection') {
		if (billingHeading) {
			billingHeading.textContent = i18n.yourDetails || 'Your details';
			billingHeading.hidden = false;
		}
		if (shippingHeading) {
			shippingHeading.hidden = true;
		}
		return;
	}

	if (shippingHeading) {
		shippingHeading.textContent = i18n.deliveryDetails || 'Delivery details';
		shippingHeading.hidden = Boolean(onBillingPanel);
	}

	if (billingHeading) {
		billingHeading.textContent = onBillingPanel
			? i18n.billingAddress || 'Billing address'
			: i18n.contactDetails || 'Contact';
		billingHeading.hidden = false;
	}
}

function setWcShipDifferent(checked) {
	const wcCheckbox = getWcShipCheckbox();
	if (!wcCheckbox) {
		return;
	}
	if (wcCheckbox.checked !== checked) {
		wcCheckbox.checked = checked;
		wcCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
	}
}

function forceShippingAddressVisibility(show) {
	const form = document.querySelector('[data-dc-checkout]');
	form?.classList.toggle('is-showing-delivery-address', show);

	document.querySelectorAll('.dc-checkout .woocommerce-shipping-fields .shipping_address').forEach((el) => {
		if (show) {
			el.style.setProperty('display', 'block', 'important');
			el.style.setProperty('height', 'auto', 'important');
			el.style.setProperty('overflow', 'visible', 'important');
			el.style.removeProperty('padding-top');
			el.style.removeProperty('margin-top');
			el.style.removeProperty('border-top-width');
		} else {
			el.style.setProperty('display', 'none', 'important');
		}
	});
}

const ADDRESS_KEYS = [
	'first_name',
	'last_name',
	'company',
	'country',
	'address_1',
	'address_2',
	'city',
	'state',
	'postcode',
];

function copyShippingToBillingFields() {
	ADDRESS_KEYS.forEach((key) => {
		const shipping = document.getElementById(`shipping_${key}`);
		const billing = document.getElementById(`billing_${key}`);
		if (shipping && billing) {
			billing.value = shipping.value;
			billing.dispatchEvent(new Event('change', { bubbles: true }));
		}
	});
}

function bindCheckoutSubmitSync() {
	const form = document.querySelector('form.checkout[data-dc-checkout], form.checkout.dc-checkout');
	if (!form || form.dataset.dcAddressSyncBound === 'true') {
		return;
	}

	form.dataset.dcAddressSyncBound = 'true';
	form.addEventListener(
		'submit',
		() => {
			if (getDeliveryMethod() === 'collection') {
				return;
			}
			const different = Boolean(getBillingDifferentToggle()?.checked);
			if (!different) {
				copyShippingToBillingFields();
			}
			setWcShipDifferent(true);
		},
		true
	);
}

function syncAddressPanels() {
	const method = getDeliveryMethod();
	const form = document.querySelector('[data-dc-checkout]');
	const toggleWrap = document.querySelector('[data-ship-toggle]');
	const themeToggle = getBillingDifferentToggle();
	const nav = document.querySelector('[data-address-nav]');
	const continueBtn = document.querySelector('[data-address-continue]');
	const backBtn = document.querySelector('[data-address-back]');

	if (method === 'collection') {
		if (themeToggle) {
			themeToggle.checked = false;
		}
		form?.classList.remove('is-billing-different', 'is-address-billing');
		if (toggleWrap) {
			toggleWrap.hidden = true;
		}
		if (nav) {
			nav.hidden = true;
		}
		if (continueBtn) {
			continueBtn.hidden = true;
		}
		if (backBtn) {
			backBtn.hidden = true;
		}
		setWcShipDifferent(false);
		forceShippingAddressVisibility(false);
		updateHeadings(method, false);
		return;
	}

	if (toggleWrap) {
		toggleWrap.hidden = false;
	}

	const different = Boolean(themeToggle?.checked);
	const onBillingPanel = Boolean(form?.classList.contains('is-address-billing'));

	form?.classList.toggle('is-billing-different', different);

	// Shipping is always the delivery destination for Delivery.
	setWcShipDifferent(true);
	forceShippingAddressVisibility(!Boolean(different && form?.classList.contains('is-address-billing')));

	if (!different) {
		form?.classList.remove('is-address-billing');
	}

	const showingBilling = different && form?.classList.contains('is-address-billing');

	if (nav) {
		nav.hidden = !different;
	}
	if (continueBtn) {
		continueBtn.hidden = !different || showingBilling;
	}
	if (backBtn) {
		backBtn.hidden = !showingBilling;
	}
	if (toggleWrap) {
		toggleWrap.hidden = Boolean(showingBilling);
	}

	updateHeadings(method, showingBilling);
}

function bindAddressNav() {
	const continueBtn = document.querySelector('[data-address-continue]');
	const backBtn = document.querySelector('[data-address-back]');
	const form = document.querySelector('[data-dc-checkout]');

	if (continueBtn && continueBtn.dataset.bound !== 'true') {
		continueBtn.dataset.bound = 'true';
		continueBtn.addEventListener('click', () => {
			form?.classList.add('is-address-billing');
			syncAddressPanels();
			window.setTimeout(() => syncAllFloating(), 0);
		});
	}

	if (backBtn && backBtn.dataset.bound !== 'true') {
		backBtn.dataset.bound = 'true';
		backBtn.addEventListener('click', () => {
			form?.classList.remove('is-address-billing');
			syncAddressPanels();
			window.setTimeout(() => syncAllFloating(), 0);
		});
	}
}

function bindBillingDifferentToggle() {
	const themeToggle = getBillingDifferentToggle();
	if (!themeToggle || themeToggle.dataset.bound === 'true') {
		return;
	}

	themeToggle.dataset.bound = 'true';
	themeToggle.addEventListener('change', () => {
		const form = document.querySelector('[data-dc-checkout]');
		if (!themeToggle.checked) {
			form?.classList.remove('is-address-billing');
		}
		syncAddressPanels();
		window.setTimeout(() => syncAllFloating(), 0);
	});
}

function bindFloatingFields(root = document) {
	const checkout = root.querySelector?.('.dc-checkout') || document.querySelector('.dc-checkout');
	if (!checkout) {
		return;
	}

	checkout.querySelectorAll('.form-row').forEach((row) => {
		const control =
			row.querySelector('input.input-text, textarea, select') ||
			row.querySelector('input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"])');
		if (!control || control.dataset.dcFloatBound === 'true') {
			return;
		}
		control.dataset.dcFloatBound = 'true';
		['focus', 'blur', 'input', 'change'].forEach((evt) => {
			control.addEventListener(evt, () => syncFloatingRow(row));
		});
		syncFloatingRow(row);
	});
}

function bindCouponApply() {
	const root = document.querySelector('[data-dc-coupon]');
	if (!root || root.dataset.bound === 'true') {
		return;
	}

	root.dataset.bound = 'true';
	const button = root.querySelector('[data-dc-coupon-apply]');
	const input = root.querySelector('#dc_coupon_code, input[name="coupon_code"]');
	const nonce = root.querySelector('[data-dc-coupon-nonce]');

	button?.addEventListener('click', async () => {
		const code = String(input?.value || '').trim();
		if (!code) {
			return;
		}

		button.disabled = true;
		try {
			const params = window.wc_checkout_params || {};
			const endpoint = (params.wc_ajax_url || '').toString().replace('%%endpoint%%', 'apply_coupon');
			if (!endpoint) {
				throw new Error('missing endpoint');
			}

			const body = new URLSearchParams();
			body.set('coupon_code', code);
			body.set('security', nonce?.value || params.apply_coupon_nonce || '');

			const response = await fetch(endpoint, {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
				body: body.toString(),
			});
			const html = await response.text();

			if (typeof window.jQuery !== 'undefined') {
				const $ = window.jQuery;
				$('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();
				if (html) {
					$('form.checkout').before(html);
				}
				$(document.body).trigger('update_checkout', { update_shipping_method: false });
			}
		} catch {
			// Checkout update will surface validation if needed.
		} finally {
			button.disabled = false;
		}
	});
}

export function applyCheckoutDeliveryMethod(method) {
	setDeliveryMethod(method === 'collection' || method === 'delivery' ? method : '');
	syncAddressPanels();
	bindBillingDifferentToggle();
	bindAddressNav();
	bindCheckoutSubmitSync();
	bindFloatingFields();
	ensureOrderNotesDisclosure();
	syncAllFloating();
}

export function initCheckoutFields() {
	const checkout = document.querySelector('[data-dc-checkout], .dc-checkout');
	if (!checkout) {
		return;
	}

	ensureOrderNotesDisclosure();
	bindFloatingFields();
	bindBillingDifferentToggle();
	bindAddressNav();
	bindCheckoutSubmitSync();
	bindCouponApply();
	syncAllFloating();

	if (checkout.dataset.deliveryMethod === 'collection' || checkout.dataset.deliveryMethod === 'delivery') {
		applyCheckoutDeliveryMethod(checkout.dataset.deliveryMethod);
	}

	document.body.addEventListener('updated_checkout', () => {
		window.requestAnimationFrame(() => {
			ensureOrderNotesDisclosure();
			bindFloatingFields();
			bindBillingDifferentToggle();
			bindAddressNav();
			bindCheckoutSubmitSync();
			bindCouponApply();
			syncAddressPanels();
			syncAllFloating();
		});
	});

	document.addEventListener('dc:delivery-method', (event) => {
		const method = event?.detail?.method;
		if (method) {
			applyCheckoutDeliveryMethod(method);
		}
	});
}
